import React from 'react'
import { Link } from 'react-router-dom'
import Button from './Button'

interface IBoxLarge {
  bgGreen?: boolean
  title: string
  subTitle: string
  text?: string
  buttonText: string
  alignRight?: boolean
  link?: string
}

const BoxLarge = ({bgGreen = true, title, subTitle, text, buttonText, alignRight = false, link = "/"}:IBoxLarge) => {
  return (
    <div className={`__box-large d-flex flex-column justify-content-between ${bgGreen ? "" : "bgWhite"} ${alignRight ? "alignRight" : ""}`}>
      <h1>{title}</h1>
      <h4>{subTitle}</h4>
      <div className='__wrapper d-flex flex-column flex-lg-row justify-content-between'>
        <p className='me-5' >{text}</p>
        <div className='me-auto d-flex flex-column justify-content-end'>
          <Link to={link}>
            <Button colorGreen={bgGreen ? false : true} buttonText={buttonText}/>   
          </Link>
   
        </div>

      </div>

    </div>
  )
}

export default BoxLarge